import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from "../../../../helpers/api_helper";

// 🚀 Fetch Saga
function* fetchSalaryScaleSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_SALARY_SCALE, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Salary Scale!');
    }

    yield put({ type: types.FETCH_SALARY_SCALE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while fetching!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.FETCH_SALARY_SCALE_FAILURE, payload: error });
  }
}

// 💾 Save Saga
function* saveSalaryScaleSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_SALARY_SCALE, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Salary Scale!');
    }

    yield put({ type: types.SAVE_SALARY_SCALE_SUCCESS, payload: response });
    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_SALARY_SCALE_FAILURE, payload: error });
  }
}

// 🔄 Change Status Saga
function* changeSalaryScaleStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_CHANGE_SALARY_SCALE_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.CHANGE_SALARY_SCALE_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while updating status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_SALARY_SCALE_STATUS_FAILURE, payload: error });
  }
}

// 🔄 Root Saga
export default function* salaryScaleSaga() {
  yield all([
    takeLatest(types.FETCH_SALARY_SCALE, fetchSalaryScaleSaga),
    takeLatest(types.SAVE_SALARY_SCALE, saveSalaryScaleSaga),
    takeLatest(types.CHANGE_SALARY_SCALE_STATUS, changeSalaryScaleStatusSaga),
  ]);
}
